export default "__VITE_ASSET__DPwpt6DD__"